import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, timer } from 'rxjs';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import { DashCam } from '../cctv-cameras/cctv-cameras.component';


@Component({
  selector: 'stream-loader',
  templateUrl: './cctv-stream-loader.component.html',
  styleUrls: ['./cctv-stream-loader.component.css']
})

export class CctvStreamLoaderComponent implements OnInit {

  max_attempts: number = 10;
  attempt_count: number = 0;
  iTimeSpent: number = 5000;
  private subscription?: Subscription;

  @Input() isHideInfo: boolean = false;
  @Input() obj_Camera!: any;
  @Input() expiresAt!: number;
  @Input() tripId!: number;
  @Input() tiChannel!: number;
  @Input() ScreenShot!: boolean;
  @Output() hideComponent = new EventEmitter();
  @Output() updateChecked = new EventEmitter<any>();

  constructor(
    private _tooltip: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private route: ActivatedRoute,
    private gurdService: GurdServiceService,
    private _fb: FormBuilder,
    private httpClient: HttpClient,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {

    if (!this.tiChannel) {

      this.tiChannel = this.obj_Camera.strUnitId.split('-')[1];

    }

    if (!this.obj_Camera.strUrl) {
      this.attempt_count = 1;
      const channel = this.tiChannel == 0 ? 'front' : 'inside';
      this.sendStartRequest(this.obj_Camera, channel);
    }

  }

  ngOnDestroy() {

    this.subscription?.unsubscribe();

    // this.attempt_count  = this.max_attempts ;

  }

  async sendStartRequest(item, channel: 'front' | 'inside') {

    let model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: this.obj_Camera.strUnitId.split('-')[0],

      tiChannel: channel == 'front' ? 0 : 1,

      ClientId: this.gurdService.decrypt(localStorage.getItem('clientId')!) || '',

      Token: this.gurdService.decrypt(localStorage.getItem('token')!) || '',

    }

    this.otherService.Showspinner();

    const resp = await axios.post(`Dashcam_SendCommand4VideoStream`, this.otherService.stringNumberToNumber(model));

    this.otherService.nonespinner();

    let res = JSON.parse(resp.data);

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x12q1dss1110' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    // دوربین جلو

    if (channel == 'front') {

      const dashCam = {

        strUnitId: this.obj_Camera.strUnitId,

        iDeviceCommand: 'ندارد',

        fullName: item.fullName,

        channel: 'وقایع',

        strUrl: '',

      }

      this.updateChecked.emit(dashCam)

      this.attempt_count = 1;

      this.loadOrQueueStream(item, channel);

    }

    // دوربین کابین

    if (channel == 'inside') {

      const dashCam = {

        strUnitId: this.obj_Camera.strUnitId,

        iDeviceCommand: 'ندارد',

        fullName: item.fullName,

        channel: 'کابین',

        strUrl: ''

      }

      this.updateChecked.emit(dashCam)

      this.attempt_count = 1;

      this.loadOrQueueStream(item, channel);

    }

  }

  async getStreamingUrl(item, channel: 'front' | 'inside') {

    let model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: this.obj_Camera.strUnitId.split('-')[0],

      tiChannel: channel == 'front' ? 0 : 1
    }

    const resp = await axios.post(`Dashcam_GetLiveStreamURLByIDAndChanel`, this.otherService.stringNumberToNumber(model));

    let res = JSON.parse(resp.data);

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x12streaming1110' } });

      return;

    }

    if (res.iResult == 0) {

      this.attempt_count = 0;

      return this._tooltip.showError(res.strError);

    }

    if ((this.attempt_count >= this.max_attempts) && !this.obj_Camera.strUrl) {
      this.hideComponent.emit(this.obj_Camera);
      return this._tooltip.showError(`پاسخی از دوربین ${this.obj_Camera.fullName} - ${this.obj_Camera.channel} دریافت نشد!`)
    }

    if (res?.strFLVURL && res.strFLVURL != '') {

      this.subscription?.unsubscribe();

      this.obj_Camera.strUrl = res?.strFLVURL;

      this.updateChecked.emit(this.obj_Camera);

      this.attempt_count = 0;

      return;

    }

    if (res?.strHLSURL && res.strHLSURL != '') {

      this.subscription?.unsubscribe();

      this.obj_Camera.strUrl = res?.strHLSURL;

      this.updateChecked.emit(this.obj_Camera);

      this.attempt_count = 0;

      return;


    }

    if (!res?.strHLSURL && !res?.strFLVURL) {

      this.subscription?.unsubscribe();

      this.subscription = timer(this.iTimeSpent).subscribe(() => {

        this.attempt_count++;

        this.getStreamingUrl(item, channel);

      })

    }

  }

  async loadOrQueueStream(item, channel: 'front' | 'inside') {

    let model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strUnitID: item.strUnitId.split('-')[0],

      ClientId: this.gurdService.decrypt(localStorage.getItem('clientId')!) || '',

      Token: this.gurdService.decrypt(localStorage.getItem('token')!) || '',

    }

    const resp = await axios.post(`Dashcam_CheckOnlineFull`, this.otherService.stringNumberToNumber(model));

    let res = JSON.parse(resp.data);

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x12q1dsxss1110' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    if (this.obj_Camera.strUrl) {

      this.subscription?.unsubscribe();

      return;

    }

    if ((this.attempt_count >= this.max_attempts) && !this.obj_Camera.strUrl) {
      this.showError(model);
    }

    if (res.Online) {

      if (channel == 'front' && res.Ch1 == 1) {
        this.subscription?.unsubscribe();
        res.strUnitID = res.IMEI;
        this.appendOnlineDashCams([res], channel);
      }

      if (channel == 'inside' && res.Ch2 == 1) {
        this.subscription?.unsubscribe();
        res.strUnitID = res.IMEI;
        this.appendOnlineDashCams([res], channel)

      }

      else {
        this.subscription?.unsubscribe();
        this.subscription = timer(this.iTimeSpent).subscribe(() => {
          this.attempt_count++;
          this.loadOrQueueStream(item, channel);
        })
      }

    }

    else {

      if (res.strMessage && this.attempt_count % 2 == 0) {
        this._tooltip.showInfo(res.strMessage, '')
      }

      this.subscription?.unsubscribe();
      this.subscription = timer(this.iTimeSpent).subscribe(() => {
        this.attempt_count++;
        this.loadOrQueueStream(item, channel);
      })
    }

  }

  async appendOnlineDashCams(response, channel: 'front' | 'inside') {

    response.forEach((car) => {

      if (!car?.Online) return;

      if (car?.Ch1 === 1 && channel == 'front') {
        const dashCamFront = this.buildDashCam(car, 'front');
        this.obj_Camera = dashCamFront;
        this.updateChecked.emit(dashCamFront);
      }

      if (car?.Ch2 === 1 && channel == 'inside') {
        const dashCamInside = this.buildDashCam(car, 'inside');
        this.obj_Camera = dashCamInside;
        this.updateChecked.emit(dashCamInside);
      }

    })

  }

  async showError(model) {

    const resp = await axios.post(`Dashcam_GetLastResponce2Command`, this.otherService.stringNumberToNumber(model));

    let res = JSON.parse(resp.data);
    this.subscription?.unsubscribe();
    this.hideComponent.emit(this.obj_Camera);

    if (res.ISSessionExpired == true) {

      this._tooltip.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: 'x12q1dsxss1110' } });

      return;

    }

    if (res.iResult == 0) {

      return this._tooltip.showError(res.strError);

    }

    if (res.strMessage) {

      return this._tooltip.showError(res.strMessage)

    }

    else {

      this._tooltip.showError(`پاسخی از دوربین ${this.obj_Camera.fullName} - ${this.obj_Camera.channel} دریافت نشد!`);

    }

  }

  buildDashCam(item: any, channel: 'front' | 'inside'): DashCam {
    const suffix = channel === 'front' ? '-0' : '-1';
    const targetId = (item.strUnitID ?? item.IMEI) + suffix;
    const channelName = channel === 'front' ? 'وقایع' : 'کابین';
    const finalUrl = this.getDashCamUrl(item, channel) ?? item?.strUrl

    return {
      strUnitId: targetId,
      channel: channelName,
      fullName: item.strFullName ?? '',
      strUrl: finalUrl ?? '',
      iDeviceCommand: 'ندارد',
      tiChannel: suffix.replace('-', ''),
      clients: item.Clients ?? '',
      liveTime: item.StartLiveTime ?? ''
    };
  }

  getDashCamUrl(item: any, channel: 'front' | 'inside'): string {
    if (!item?.Online) return '';

    const isFront = channel === 'front';
    const urlKey = isFront ? 'strCh1FLVURL' : 'strCh2FLVURL';
    const url = item?.[urlKey];
    return typeof url === 'string' ? url : '';
  }

}
